<div
  class="left-0 w-full z-10 transition-all duration-200 ease-in-out"
  [class.opacity-100]="isSelected()"
  [class.translate-y-0]="isSelected()"
  [class.opacity-0]="!isSelected()"
  [class.h-0]="!isSelected()"
  [style.pointer-events]="isSelected() ? 'auto' : 'none'"
  [style.visibility]="isSelected() ? 'visible' : 'hidden'"
  [class.mt-3]="isSelected()"
>
  <div
    (click)="$event.stopPropagation()"
    class="ml-7 animate-in fade-in slide-in-from-top-1 duration-200"
  >
    <input
      #inputEl
      type="text"
      [name]="name + '_' + optionKey + '_oe'"
      [placeholder]="placeholder || 'Please specify...'"
      class="block w-full px-3 py-2 text-sm text-slate-900 border border-slate-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
      (input)="onInputChange($event)"
      [attr.data-question-name]="name"
      [attr.data-purpose]="name + '_oe'"
      [attr.data-oe-parent-key]="optionKey"
    />
    <!-- <input
      type="hidden"
      class="oe-map"
      [attr.data-key]="optionKey"
      [name]="'oe_mapping[' + optionKey + '][' + optionKey + ']'"
      [value]="name + '_' + optionKey + '_oe'"
      disabled
    /> -->
  </div>
</div>
